import { render } from "./ProfileComponent.vue?vue&type=template&id=a2da0f6a"
import script from "./ProfileComponent.vue?vue&type=script&defer=true&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&defer=true&lang=js"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__